module.exports = __webpack_public_path__ + "media/images/system-feature-4@2x-86a107a8.png";